import React, { Component } from 'react';
import { Form, FormGroup } from 'reactstrap';
import '../../../web/index.css'
import * as FontAwesome from 'react-icons/lib/fa';

export default class FacilityList extends Component {
    render() {
        return (
            <div className = "col-md-4 box ">
                <div className = "cHeader"> Facilities</div>
                {this.props.FacilityData.map(x =>
                    <div className ="fCard" key={x.id}>
                        <p className="facilities">{x.name}</p>
                    </div>
                )}
            </div>
            )
        }
}


// WEBPACK FOOTER //
// ./src/shared/containers/PeriodicalScheduling/facility_list.js